import React from 'react';
import {withRouter} from "react-router";
import {Link} from 'react-router-dom';

import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ReCAPTCHA from "react-google-recaptcha";

import API from "@beardeddevops/react.api";
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

/**
 *  @property {Admins_Object} state
 *  @property {object} model
 *  @property {Admins_Properties} model.properties
 *  @property {Admins_Is} model.is
 *  @property {Admins_Has} model.has
 */
class Login extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Admins._name);
		this.model.requestType = API.RequestType.READ;
		this.recaptchaRef = React.createRef();
		this.brand = APPCONFIG.brand;
		this.shouldAutoLoad = false;
		this.state.turnstile_token = '';
		this.turnstileWidgetId = null;
	}

	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();

		this.setState({loading: true});
		if (this.handleProcess(null, API.RequestType.READ)) {
			try {
				await this.model.submit(this, API.RequestType.READ);
				this.props.history.push('/dashboard');
			} catch (error) {
				this.resetTurnstileChallenge();
				return false;
			}

		} else {
			this.setState({loading: false});
		}
		return false;
	};

	componentDidMount() {
		super.componentDidMount();
		if (window.turnstile) {
			this.renderTurnstile();
			return;
		}
		const turnstileScript = document.createElement("script");
		turnstileScript.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
		turnstileScript.defer = true;
		turnstileScript.onload = this.renderTurnstile;
		document.head.appendChild(turnstileScript);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		this.removeTurnstileChallenge();
	}

	// Test Manual Required Check: sitekey: "3x00000000000000000000FF"
	//Test Forced Failure: sitekey: "2x00000000000000000000AB"
	renderTurnstile = () => {
		if (!this._ismounted || !window.turnstile || !document.querySelector("#turnstile-widget") || this.turnstileWidgetId !== null) {
			return;
		}

		this.turnstileWidgetId = window.turnstile.render("#turnstile-widget", {
			sitekey: APPCONFIG.turnstile,
			action: "login",
			callback: (token) => {
				this.setState({turnstile_token: token});
			},
			"error-callback": (errorCode) => {
				console.error("Turnstile error:", errorCode);
				this.setState({turnstile_token: ''});
			},
			"expired-callback": () => this.setState({turnstile_token: ''}),
		});
	};

	resetTurnstileChallenge = () => {
		if (window.turnstile && this.turnstileWidgetId !== null) {
			window.turnstile.reset(this.turnstileWidgetId);
		}
		this.setState({turnstile_token: '', loading: false});
	};

	removeTurnstileChallenge = () => {
		if (window.turnstile && this.turnstileWidgetId !== null) {
			window.turnstile.remove(this.turnstileWidgetId);
		}
		this.turnstileWidgetId = null;
	};

	handleKeyPress = (event) => {
		if (event.key === 'Enter' && this.state.turnstile_token) {
			this.handleSubmit();
		}
	}

	render() {
		let {properties} = this.model;
		let object = this.state;
		let brand = this.brand;
		return (
			<div className="body-inner"
				tabIndex={0}
				onKeyDown={this.handleKeyPress}>
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<section className="logo text-center">
							<h1>{brand} Admin</h1>
						</section>

						<fieldset>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.email}
									error={object.email_error}
									property={properties.email}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
								/>
							</div>
							<br/>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.password}
									error={object.password_error}
									property={properties.password}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
									type={"password"}
								/>
							</div>
							<br/>
							<div id="turnstile-widget"></div>
							{/*{process.env.production &&*/}
							{/*<div style={{textAlign: 'center', paddingTop: '10px'}}>*/}
							{/*	<ReCAPTCHA*/}
							{/*		sitekey={APPCONFIG.reCAPTCHA}*/}
							{/*		ref={this.recaptchaRef}*/}
							{/*		onChange={this.onChange}*/}
							{/*		onExpired={this.onExpired.bind(this)}*/}
							{/*		style={{*/}
							{/*			display: 'inline-block'*/}
							{/*		}}*/}
							{/*	/>*/}
							{/*</div>*/}
							{/*}*/}
						</fieldset>

					</CardContent>
					<CardActions className={'justify-content-end'}>
						<Button
							onClick={this.handleSubmit}
							type={"submit"}
							id={"button-login"}
							color="primary"
							size={"md"}
							disabled={!object.turnstile_token}
							block={false}>Login</Button>
					</CardActions>
				</Card>
				<div className="additional-info">
					<span style={{'color': '#909090'}}>Version {process.env.version} | {APPCONFIG.copyright}-{APPCONFIG.year} © <a className="brand" target="_blank" href={APPCONFIG.productLink} style={{'color': '#525252'}}>{APPCONFIG.brand}</a></span><br />
				</div>

			</div>
		);
	}
}

const LoginRoute = withRouter(Login);
const Page = () => (
	<div className="page-login">
		<div className="main-body">
			<div key="1">
				<LoginRoute/>
			</div>
		</div>
	</div>
);

export default Page;